import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import type { DistributionItem } from '../chartTypes.ts';
import { HOUSEHOLD_SIZE_BUCKETS } from '../constants.ts';
import { parseDistribution } from './utils.ts';

export const parseHouseholdSize = (response: HouseholdInsightsApiResponse | undefined): DistributionItem[] =>
  parseDistribution(response?.household_size, HOUSEHOLD_SIZE_BUCKETS);
